export const NUTRIENTS = [
	'N',
	'P',
	'K',
	'Ca',
	'Mg',
	'S',
	'B',
	'Cu',
	'Fe',
	'Mn',
	'Zn',
] as const;

export type Nutrient = (typeof NUTRIENTS)[number];

export const NUTRIENT_LABELS: Record<Nutrient, string> = {
	N: 'N',
	P: 'P',
	K: 'K',
	Ca: 'Ca',
	Mg: 'Mg',
	S: 'S',
	B: 'B',
	Cu: 'Cu',
	Fe: 'Fe',
	Mn: 'Mn',
	Zn: 'Zn',
};

export const NUTRIENT_NAMES: Record<Nutrient, string> = {
	N: 'Nitrogênio',
	P: 'Fósforo',
	K: 'Potássio',
	Ca: 'Cálcio',
	Mg: 'Magnésio',
	S: 'Enxofre',
	B: 'Boro',
	Cu: 'Cobre',
	Fe: 'Ferro',
	Mn: 'Manganês',
	Zn: 'Zinco',
};
